export const PLAYLIST_TITLE_MIN = 3
export const PLAYLIST_TITLE_MAX = 100
export const PLAYLIST_DEFAULT_MAX_LISTS = 3
export const PLAYLIST_PRO_MAX_LISTS = 1000
export const PLAYLIST_DEFAULT_MAX_PEOPLE = 20
export const PLAYLIST_PRO_MAX_PEOPLE = 200
export const PLAYLIST_DEFAULT_MAX_SHARES = 3
export const PLAYLIST_PRO_MAX_SHARES = 25
export const VITE_PROSEARCH_VERSION = "v5.0.20"; // 'not set'
export const BIO_TEXT_MAX_LENGTH = 3048

// Regular Expression Pattern (Ref: https://bit.ly/33cv2vn)
// eslint-disable-next-line
export const EMAIL_REGEX_PATTERN =
  /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i
export const PHONE_REGEX_PATTERN = /^\+?[0-9.() -]{7,32}$/
